import { createSongDocument, type RevisionContent, type Song, type SongDocument } from '../domain'
import { newId } from './ids'

export interface NewSongInput {
  title: string
  artist: string
  content: RevisionContent
  /** Fecha ISO. */
  now: string
  author?: 'import' | 'user'
  /** La web de la que se copió el texto, para dejarla anotada en la canción. */
  sourceUrl?: string
  reason?: string
}

/** Una dirección con pinta de web, o undefined. */
export function parseSourceUrl(text: string | undefined): URL | undefined {
  if (!text) return undefined
  try {
    const url = new URL(text.trim())
    return url.protocol === 'http:' || url.protocol === 'https:' ? url : undefined
  } catch {
    return undefined
  }
}

/** Monta una ficha nueva con IDs globales nuevos: canción, arreglo «Original» y su revisión. */
export function newSongDocument(input: NewSongInput): SongDocument {
  const document = createSongDocument({
    ids: { song: newId('song'), arrangement: newId('arr'), revision: newId('rev') },
    now: input.now,
    title: input.title.trim(),
    artist: input.artist.trim(),
    author: input.author ?? 'import',
    content: input.content,
    ...(input.reason ? { reason: input.reason } : {}),
  })
  const url = parseSourceUrl(input.sourceUrl)
  if (url) {
    const song: Song = {
      ...document.song,
      links: [{ url: url.href, label: url.hostname, terms: 'Uso privado' }],
    }
    return { ...document, song }
  }
  return document
}
